const LS_KEY = 'mdv.catalogueSnapshot';
const DEFAULT_MODELS_CACHE = 'mdv-models-mdv-offline-v1';

export function saveCatalogueSnapshot(data) {
  if (!data || typeof data !== 'object') return;
  try {
    localStorage.setItem(
      LS_KEY,
      JSON.stringify({
        savedAt: new Date().toISOString(),
        models: data.models || null,
        layers: data.layers || null,
      })
    );
  } catch {
    // quota / private mode
  }
}

export function readCatalogueSnapshot() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data !== 'object') return null;
    return data;
  } catch {
    return null;
  }
}

export function clearCatalogueSnapshot() {
  try {
    localStorage.removeItem(LS_KEY);
  } catch {
    // ignore
  }
}

function relFromModelsPathname(pathname) {
  const m = String(pathname || '').match(/\/models\/(.+\.(?:glb|zip))$/i);
  return m ? m[1] : null;
}

/**
 * Build list_models-style sections from GLB/ZIP entries already in Cache Storage.
 * Used when list_models.php is unreachable and no snapshot exists yet.
 */
export async function sectionsFromModelCache() {
  if (!('caches' in window)) return [];
  let keys = [];
  try {
    const all = await caches.keys();
    const names = all.filter((k) => k.startsWith('mdv-models-') || k.startsWith('dv-models-'));
    if (!names.length) names.push(DEFAULT_MODELS_CACHE);
    for (const name of names) {
      try {
        const cache = await caches.open(name);
        keys = keys.concat(await cache.keys());
      } catch {
        /* ignore */
      }
    }
  } catch {
    return [];
  }

  const byPath = new Map();
  keys.forEach((req) => {
    let u;
    try {
      u = new URL(req.url);
    } catch {
      return;
    }
    const rel = relFromModelsPathname(u.pathname);
    if (!rel) return;
    const parts = rel.split('/').filter(Boolean);
    const fileName = parts.pop();
    if (!fileName) return;
    const ext = fileName.split('.').pop().toLowerCase();
    const baseName = fileName.replace(/\.(glb|zip)$/i, '');
    let group = 'Other';
    let category = 'Models';
    if (parts.length >= 2) {
      group = parts[0];
      category = parts.slice(1).join('/');
    } else if (parts.length === 1) {
      group = parts[0];
      category = 'Models';
    }
    const path = `models/${rel}`;
    const model = {
      name: path,
      displayName: baseName,
      url: req.url,
      path,
    };
    if (ext === 'zip') model.type = 'blockmodel';
    const prev = byPath.get(path);
    if (!prev) {
      byPath.set(path, { group, category, model });
      return;
    }
    const prevV = String(prev.model.url || '').length;
    if (req.url.length >= prevV) byPath.set(path, { group, category, model });
  });

  const sectionMap = new Map();
  byPath.forEach(({ group, category, model }) => {
    const key = `${group}\0${category}`;
    if (!sectionMap.has(key)) {
      sectionMap.set(key, { group, name: category, models: [] });
    }
    sectionMap.get(key).models.push(model);
  });
  return Array.from(sectionMap.values());
}
